import { render } from "./PermohonanDayaView.vue?vue&type=template&id=11bb5e70&scoped=true&ts=true"
import script from "./PermohonanDayaView.vue?vue&type=script&lang=ts"
export * from "./PermohonanDayaView.vue?vue&type=script&lang=ts"

import "./PermohonanDayaView.vue?vue&type=style&index=0&id=11bb5e70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bb5e70"]])

export default __exports__